<template>
  <div class=" d-flex justify-content-center align-items-center flex-grow-1">
      <div class="container  d-flex justify-content-center align-items-center flex-column">
          <template v-if="user.type == 1 || user.type == 2">
              <PolicyModal></PolicyModal>
              <div class="greeting__wrapper">
                  <h5>{{$t('Mieter.Welcome')}} <br> <span>{{userObject.vorname}} {{ userObject.nachname}}</span></h5>
                <div class="row">
                  <div class="col-8 offset-2">
                    <p>{{$t('Mieter.WelcomeInfo')}}</p>
                  </div>
                </div>

              </div>
              <div class="dashboard__buttons dashboard__mieter d-flex align-items-center justify-center flex-column flex-lg-row" v-if="user.type == 1">
              <div class="dashboard__button dashboard__item-1 mr-0 mr-lg-5">
                  <router-link :to="{ name: 'suche'}"  class="nav-links">
                      <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Mieter.Button01')}}</button>
                  </router-link>
              </div>
              <div class="dashboard__button dashboard__item-2">
                  <router-link :to="{ name: 'merkliste'}"  class="nav-links">
                      <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Mieter.Button02')}}</button>
                  </router-link>
              </div>
          </div>
              <div class="dashboard__buttons dashboard__vermieter d-flex align-items-center mt-8" v-if="user.type == 2">
                  <div class="dashboard__button dashboard__item-1 mr-5">
                      <router-link :to="{ name: 'angeboteNeu'}"  class="nav-links">
                          <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Vermieter.Button01')}}</button>
                      </router-link>
                  </div>
                  <div class="dashboard__button dashboard__item-2">
                      <router-link :to="{ name: 'meineliste'}"  class="nav-links">
                          <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Vermieter.Button02')}}</button>
                      </router-link>
                  </div>
              </div>
          </template>
          <template v-if="user.type == 0">

              <div class="greeting__wrapper">
                  <h5>Willkommen!</h5>

                  <div class="user_activation d-flex flex-column mt-5" >
                      <p>Es gibt {{userToActivate}} neue Accounts die aktiviert werden müssen.</p>

                      <router-link :to="{ name: 'activateUser'}"  class="nav-links" v-if="userToActivate > 0">
                          <button type="button" class="btn btn-outline-danger waves-effect">Zur Aktivierung</button>
                      </router-link>
                  </div>
<!--                  <div class="find__user-login mt-5">
                      <h4>Letzter Login:</h4>
                      <mdb-input type="text" required label="E-Mail" v-model="username"/>
                      <button type="button" class="btn btn-outline-danger waves-effect" v-on:click="searchUserLogin()">Suchen</button>

                      <div class="find__user-login&#45;&#45;answer mt-5">
                          <template v-if="lastlogin != ''">
                              <p>Der Benutzer war das letzte mal Online: {{lastlogin}}</p>
                          </template>
                          <template v-else-if="lastlogin == '' && usernameTyping == false">
                              <p>Keinen Benutzer mit dieser Email gefunden.</p>
                          </template>
                          <template v-else>
                              <p></p>
                          </template>
                      </div>
                  </div>-->
              </div>
          </template>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Upload from "@/components/MultipleFiles";
import { authComputed } from '../helpers/helper.js'
import Merkliste from "@/views/Angebote/Merkliste";
import Login from "@/views/User/Login";
import AngebotService from "@/services/AngebotService";
import Angebot from "../components/angebot/admin/Angebot";
import UserService from "../services/UserService";
import PolicyModal from "@/components/PolicyModal";

export default {
  name: "home",
  components: {
        Upload,
        Merkliste,
        Angebot,
    PolicyModal

  },
    props: {
        userObject: Object,

    },
    data(){
        return{
            freigabeCount: 0,
            AngeboteSelf: Object,
            user: Object,
            userToActivate: [],
            username: "",
            lastlogin: 0,
            usernameTyping: true
        }
    },
    methods:{
      searchUserLogin(){
          this.lastlogin = '';
          UserService.searchMieterLogin(this.username).then(response =>{
              let logintime = this.$func.formateDateFromDB(response.data[0].logintime);
              this.lastlogin = logintime;
          })
      },
        usernameTypingChange(){
          this.usernameTyping = false;
        }
    },
  mounted(){

  },
    created() {
        this.user = this.userObject;
        UserService.getUserToActivate().then(response => {
          let vermieterToActivate = response.data[1];
          let mieterToActivate = response.data[0];
          this.userToActivate = mieterToActivate.length + vermieterToActivate.length;
            //this.userToActivate = response.data; // <--- set the events when returned

        })
            .catch(error => {
                console.log("There was an error:", error.response);
            });
        if(this.userObject.type == 0){
            AngebotService.getAngeboteFreigegeben()
                .then(response => {
                    this.freigabeCount = response.data.length; // <--- set the events when returned
                })
                .catch(error => {
                    console.log("There was an error:", error.response);
                });
        } else if(this.userObject.type == 2){
            AngebotService.getAngeboteSelf(this.userObject.account)
                .then(response => {
                    this.AngeboteSelf = response.data.length; // <--- set the events when returned
                })
                .catch(error => {
                    console.log("There was an error:", error.response);
                });
        }

    }
};
</script>
<style scoped lang="scss">
    .greeting__wrapper{
        margin-bottom: 100px;
        h5{
            font-size: 65px;
            span{
                font-weight: bold;
            }
        }
        @media(max-width: 375px){
            margin-bottom: 50px;
            h5{
                font-size: 35px;
                span{
                    font-weight: bold;
                }
            }
        }
    }
    button{
        border-radius: 5px;
        &.btn{
            box-shadow: 0 1px 2px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
            &:hover{
                box-shadow: 0 3px 2px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
            }
        }
    }

</style>